export default __webpack_public_path__ + "static/media/filter-active.9e855da9.svg";